<template>
  <div class="forumListContainer">
    <div
      class="forumItemContainer"
      v-for="(forum, index) of TableList"
      :key="index"
    >
      <div class="avatarContainer">
        <el-image
          class="avatar"
          fit="cover"
          :src="forum.user.avatar"
          @click="goHomePage(forum.user.id)"
        >
        </el-image>
        <div class="name_time">
          <div
            class="display_name one_lines"
            @click="goHomePage(forum.user.id)"
          >
            <span>
              {{ forum.user.display_name }}
            </span>

            <span v-if="forum.tenant" key="tenant" class="tenant">
              （{{ forum.tenant.name }}）
            </span>
          </div>
          <div class="created_time">
            {{ forum.created_time.slice(5, 16) }}
          </div>
        </div>
      </div>
      <template v-if="mode == 'all' || mode == 'post'">
        <div class="contentContainer">
          <span
            class="tag"
            @click="
              $router.push({ name: 'forum', query: { tag_id: forum.tag_id } })
            "
          >
            #{{
              l($utils.listFilter(
                $store.state.basicInfo.tagList.forum,
                forum.tag_id
              ))
            }}#
          </span>
          {{ forum.content }}
          <!-- <template v-if="forum.overflow_status == 0">
            {{ forum.content }}
          </template>
          <template v-else-if="forum.overflow_status == 1">
            {{ forum.overflow_content }}
            <span class="overflow_btn" @click="forum.overflow_status = 2"
              >展开</span
            >
          </template>
          <template v-else-if="forum.overflow_status == 2">
            {{ forum.content }}
            <span class="overflow_btn" @click="forum.overflow_status = 1"
              >收起</span
            >
          </template> -->
        </div>
        <div class="img_arrayContainer" v-if="forum.img_array.length">
          <el-image
            v-for="item of forum.img_array"
            :key="item"
            fit="cover"
            :src="item"
            :preview-src-list="forum.img_array"
          >
          </el-image>
        </div>

        <div class="operationContainer">
          <el-dropdown
            trigger="click"
            @command="(command) => handleCommand(command, forum)"
          >
            <i class="el-icon-more"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="forum.user.id != $store.state.session.user.id"
                icon="el-icon-warning-outline"
                command="accusationItem"
                >{{l("举报")}}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="forum.user.id == $store.state.session.user.id"
                icon="el-icon-edit"
                command="editItem"
                >{{l("编辑")}}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="forum.user.id == $store.state.session.user.id"
                icon="el-icon-delete"
                command="offItem"
                >{{l("删除")}}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="operationPanel">
          <!-- <div class="operation" @click="clickPraise(forum)">
            <el-image
              fit="cover"
              :src="GetResourceUrl('forum/icon-praise.svg')"
            >
            </el-image>
            <div class="count">777</div>
          </div> -->

          <div class="operation" @click="goForum(forum)">
            <el-image
              fit="cover"
              :src="GetResourceUrl('forum/icon-comments.svg')"
            >
            </el-image>
            <div class="count">{{ forum.comment_count || l("评论") }}</div>
          </div>
        </div>
      </template>
      <template v-else-if="mode == 'with'">
        <div class="replyContainer">{{ forum.content }}</div>
        <div class="originContianer" @click="goForum(forum.forum)">
          <div v-if="forum.reply">
            <span>[ {{l("我的评论")}} ] </span>
            {{ forum.reply.content }}
          </div>
          <div v-else-if="forum.forum">
            <span>[ {{l("我的发帖")}} ] </span>
            {{ forum.forum.content }}
          </div>
          <div v-else>
            <span>[ {{"内容已删除或审核中"}} ]</span>
          </div>
        </div>

        <div class="operationPanel">
          <!-- 此处forum指向对方的回复，而非forum自身(forum.forum)，并非bug -->
          <div class="operation" @click="handleShowDialog(forum)">
            <el-image
              fit="cover"
              :src="GetResourceUrl('forum/icon-comments.svg')"
            >
            </el-image>
            <div class="count">{{l("回复")}}</div>
          </div>
        </div>
      </template>
      <template v-else-if="mode == 'discuss'">
        <div class="replyContainer">{{ forum.content }}</div>
        <div class="originContianer" @click="goForum(forum.forum)">
          <div v-if="forum.reply">
            <!-- <span>[ 评论 ] </span> -->
            {{ forum.reply.content }}
          </div>
          <div v-else-if="forum.forum">
            <!-- <span>[ 帖子 ] </span> -->
            {{ forum.forum.content }}
          </div>
          <div v-else>{{l("内容已删除或审核中")}}</div>
        </div>
      </template>
    </div>

    <!-- 不同于移动端，pc端的empty自带描述，因此不能和more共存 -->
    <el-empty
      v-if="!TableLoading && TableList.length == 0"
      :description="l('暂无内容')"
    ></el-empty>
    <div v-else class="more">
      <span v-if="!HasMore"> {{l("没有更多了")}} </span>
      <i v-else-if="TableLoading" class="el-icon-loading"></i>
      <span v-else-if="!TableLoading" @click="GetTableList"> {{l("查看更多")}} </span>
    </div>

    <el-dialog
      v-if="showDialog"
      width="720px"
      :title="l('回复') + '@' + dialogTarget.user.display_name"
      :visible.sync="showDialog"
      :destroy-on-close="true"
    >
      <ForumPublish
        mode="reply"
        :target="dialogTarget"
        @submitDialog="showDialog = false"
      />
    </el-dialog>

    <el-dialog
      v-if="showEditDialog"
      width="720px"
      :title="l('编辑帖子')"
      :visible.sync="showEditDialog"
      :destroy-on-close="true"
    >
      <ForumPublish
        mode="forum"
        :target_4_edit="target_4_edit"
        @submitDialog="
          showEditDialog = false;
          GetTableList(false, target_4_edit.id);
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import ForumPublish from "./ForumPublish.vue";

export default {
  name: "ForumList",
  components: { ForumPublish },
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      PageSize: 20,
      AppCursor: 0,
      HasMore: true,
      TableLoading: false,
      TableList: [],

      discussList: [],
      showDialog: false,
      dialogTarget: {},
      mode: "", //all post with discuss

      showEditDialog: false,
      target_4_edit: {},
    };
  },
  created() {
    this.mode = this.$route.query.tab || "all";
    window.addEventListener("scroll", this.handleScroll, true);
    this.GetTableList();
  },
  mounted() {},
  destroyed() {
    // 离开该页面需要移除这个监听的事件，不然会报错
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    GetTableList(clearList, fakeAppCursor) {
      if (clearList === true) {
        this.AppCursor = 0;
        this.HasMore = false;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      } else if (fakeAppCursor) {
        let fakeIndex = this.TableList.findIndex(
          (item) => item.id == fakeAppCursor
        );
        if (fakeIndex > 0) {
          this.AppCursor = this.TableList[fakeIndex - 1].id;
        } else {
          this.AppCursor = 0;
        }
        this.HasMore = false;
      }

      this.TableLoading = true;
      let requestUrl = "";
      if (this.mode == "all") {
        console.log("content", this.$store.state.headerFilter, this.content);
        requestUrl = `/api/visitor_forum/?content=${this.content}&tag_id=${
          this.$route.query.tag_id || ""
        }`;
      } else if (this.mode == "post") {
        if (this.$route.query.user_id) {
          requestUrl =
            "/api/visitor_forum/?create_user_id=" + this.$route.query.user_id;
        } else if (this.$store.state.session.user.id) {
          requestUrl =
            "/api/visitor_forum/?create_user_id=" +
            this.$store.state.session.user.id;
        } else {
          this.$store.commit("logout");
          return;
        }
      } else if (this.mode == "with") {
        requestUrl = "/api/forum/my_discuss/with_list/";
      } else if (this.mode == "discuss") {
        requestUrl = "/api/forum/my_discuss/";
      } else {
        return;
      }
      this.axios
        .get(requestUrl, {
          params: {
            ordering: this.Sorting,
            size: this.PageSize,
            app_cursor: this.AppCursor,
          },
        })
        .then((data) => {
          this.TableLoading = false;

          if (this.AppCursor == 0) {
            this.TableList = [];
          } else {
            let cursorIndex = this.TableList.findIndex(
              (item) => item.id == this.AppCursor
            );
            if (cursorIndex >= 0) {
              this.TableList.splice(cursorIndex + 1);
            }
          }
          this.HasMore = data.has_more;

          this.TableList = this.TableList.concat(
            data.results.map((item) => {
              item.img_array = JSON.parse(item.img_array);
              if (this.mode == "discuss") {
                item.user = this.$store.state.session.user;
                item.tenant = this.$store.state.session.tenant;
              }

              return item;
            })
          );
          console.log("TableList", this.TableList);

          if (this.TableList.length) {
            this.AppCursor = this.TableList[this.TableList.length - 1].id;
          }

          if (this.mode == "with") {
            this.$store.commit("updateUnreadNotify");
          }
        });
    },
    handleScroll() {
      if (!this.HasMore || this.TableLoading) return;
      if (
        document.documentElement.scrollTop >
        document.documentElement.scrollHeight - 2000
      ) {
        this.GetTableList();
      }
    },
    clickPraise(forum) {},
    goForum(forum) {
      if (forum) {
        //已删除则不跳转
        this.$openRouter({
          path: `/home/forum/${forum.id}`,
        });
      } else {
        this.$message.error("原帖内容已删除或审核中");
      }
    },
    handleShowDialog(target) {
      this.dialogTarget = this._.cloneDeep(target);
      console.log("this.dialogTarget", this.dialogTarget);
      this.showDialog = true;
    },

    handleCommand(command, forum) {
      this[command](forum);
    },
    accusationItem(forum) {
      console.log(forum);
      this.$prompt(this.l("请填写举报原因"), this.l("举报"), {
        confirmButtonText: this.l("确定"),
        cancelButtonText: this.l("取消"),
        inputPattern: /\S/,
        inputErrorMessage: this.l("请填写举报原因"),
      }).then(({ value }) => {
        this.axios.post(`/api/user_accusation/`, {
          record_sign: forum.id,
          module: "accusation",
          comment: this.l("举报论坛贴子") + "：" + value,
        });
      });
    },
    editItem(forum) {
      this.target_4_edit = {
        id: forum.id,
        tag_id: forum.tag_id,
        content: forum.content,
        img_array: forum.img_array,
        is_private: forum.is_private,
      };
      this.showEditDialog = true;
    },
    offItem(forum) {
      this.$confirm(this.l("是否确认删除") + "？", "", {
        type: "warning",
      }).then(() => {
        this.axios.put(`/api/forum/my_post/${forum.id}/off/`).then(() => {
          // var targetIndex = this.TableList.findIndex(
          //   (item) => item.id == forum.id
          // );
          // if (targetIndex != -1) {
          //   this.TableList.splice(targetIndex, 1);
          // }
          this.GetTableList(false, forum.id);
        });
      });
    },

    goHomePage(user_id) {
      if (!user_id) return;
      this.$router.push("/home/forum/?tab=post&user_id=" + user_id);
    },
  },
};
</script>


<style scoped lang="scss">
.forumListContainer {
  .forumItemContainer {
    background: #fff;
    padding: 20px;
    margin-top: 10px;
    box-sizing: border-box;
    position: relative;

    &:first-child {
      margin-top: 0;
    }
    .avatarContainer {
      display: flex;
      position: relative;
      .avatar {
        width: 42px;
        height: 42px;
        cursor: pointer;
        border-radius: 50%;
      }
      .name_time {
        margin-left: 15px;
        .display_name {
          font-weight: bold;
          max-width: 600px;
          cursor: pointer;
          .tenant {
            font-weight: normal;
            color: #666;
          }
        }
        .created_time {
          color: #999;
          font-size: 12px;
          margin-top: 6px;
        }
      }
    }
    .contentContainer {
      margin-top: 12px;
      margin-left: 57px;
      line-height: 18px;
      .tag {
        color: $warningColor;
        cursor: pointer;
      }
      .overflow_btn {
        padding-left: 10px;
        color: $warningColor;
        cursor: pointer;
      }
    }
    .img_arrayContainer {
      margin-top: 12px;
      margin-left: 57px;
      display: flex;
      flex-wrap: wrap;
      .el-image {
        width: 208px;
        height: 155px;
        border-radius: 6px;
        margin-left: 8px;
        &:nth-child(3n + 1) {
          margin-left: 0;
        }
        &:nth-child(n + 4) {
          margin-top: 8px;
        }
      }
    }

    .operationContainer {
      position: absolute;
      top: 22px;
      right: 22px;
      i {
        font-size: 16px;
        cursor: pointer;
      }
    }

    .replyContainer {
      margin-top: 12px;
      margin-left: 57px;
      line-height: 18px;
    }
    .originContianer {
      margin-top: 12px;
      margin-left: 57px;
      background: #f9f9f9;
      box-sizing: border-box;
      padding: 12px;
      cursor: pointer;
      span {
        margin-right: 10px;
      }
    }
  }
}

.operationPanel {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 22px;
  margin-top: 10px;
  // .time {
  //   color: #999;
  //   margin-right: auto;
  //   font-size: 12px;
  // }
  .operation {
    display: flex;
    color: #999;
    cursor: pointer;
    margin-left: 20px;
    .el-image {
      width: 16px;
      height: 16px;
    }
    .count {
      font-size: 12px;
      margin-left: 8px;
    }
  }
}

.commentPublishContainer {
  padding: 20px;
  border-top: 1px solid $borderPlainColor;
  background: #fff;
}
.discussListContainer {
  padding: 20px;
  border-top: 1px solid $borderPlainColor;
  background: #fff;
}

.more {
  // width: 100%;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}

/deep/.el-empty {
  background: #fff;
}
</style>

